import { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// Set the PDF worker from CDN
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const withPDFViewer = (WrappedComponent) => {
 return (props) => {
  const [numPages, setNumPages] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
   const handleResize = () => setWindowWidth(window.innerWidth);
   window.addEventListener("resize", handleResize);
   return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getResponsiveWidth = () => {
   if (windowWidth > 1000) return 1000;
   if (windowWidth > 768) return windowWidth * 0.9;
   return windowWidth * 0.95;
  };

  function onDocumentLoadSuccess({ numPages }) {
   setNumPages(numPages);
  }

  return (
   <div
    style={{
     textAlign: "center",
     width: "100%",
     padding: "1rem 0",
    }}
   >
    <Document file={props.file} onLoadSuccess={onDocumentLoadSuccess}>
     {Array.from(new Array(numPages), (el, index) => (
      <Page
       key={index}
       pageNumber={index + 1}
       renderTextLayer={false}
       renderAnnotationLayer={false}
       width={getResponsiveWidth()}
       className="pdf-page"
      />
     ))}
    </Document>

    {/* Wrapped component (if needed) */}
    <WrappedComponent {...props} />
   </div>
  );
 };
};

export default withPDFViewer;
